import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueI18n from 'vue-i18n'

// 正确导入多语言文件
import zh from './locales/zh'
import en from './locales/en'
import ja from './locales/ja'
import ko from './locales/ko'

import "../src/assets/css/animate.min.css"
import "../src/assets/css/application.css"
import "../src/assets/css/layui.css"
// import "../src/assets/css/scrollBar.css
import "../src/assets/css/share.min.css"
import "../src/assets/css/style.css"
import "../src/assets/css/swiper.min.css"

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 富文本组件
import Editor from "@/components/Editor"
Vue.component('Editor', Editor)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper);

import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VideoPlayer)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  //完全显示的时候加载
  preLoad: 1,
  //失败时显示的图片
  error: require('./assets/img/error.png'),
  //加载时显示的GIF图
  loading: require('./assets/img/loading.gif'),
  //尝试加载几次
  attempt: 1
});

Vue.config.productionTip = false

//设置超时时间
axios.defaults.timeout = 8000
//设置api地址
//全局定义axios
// axios.defaults.baseURL = 'https://y3.smartforest.cn/api/'
// axios.defaults.baseURL = '/prod-api/'

// axios.defaults.baseURL = 'https://smartforest.cn:8080/'
// axios.defaults.baseURL = 'https://test.yasubit.com:8443/prod-api/'
Vue.prototype.$fileBaseURL = 'http://8.148.144.46:9005/compressed-images/';
// Vue.prototype.$fileBaseURL = 'https://test.yasubit.com:8443/compressed-images/';
// Vue.prototype.$fileBaseURL = 'http://159.75.170.123:9002/compressed-images/';
// axios.defaults.baseURL = 'https://www.yasubit.com/prod-api/'
Vue.prototype.$http = axios
// axios.defaults.baseURL = 'http://localhost:8090/'
axios.defaults.baseURL = 'https://yasubit.com/'

// 图片服务器地址
// Vue.prototype.imgserver = 'http://192.168.10.28:9090/'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'zh', // 默认语言
  messages: {
    zh,
    en,
    ja,
    ko
  }
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
